import { useState, useEffect } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Box,
    Button,
    FormControl,
    FormHelperText,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    Select,
    Typography,
    MenuItem
} from '@mui/material';

// third party
import * as Yup from 'yup';
import { Formik } from 'formik';

// project imports
import useScriptRef from 'hooks/useScriptRef';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { strengthColor, strengthIndicator } from 'utils/password-strength';

import InputMask from 'react-input-mask';

// assets
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import { Context } from 'context/UserContext';

// API
import { useApi } from 'Service/axios';

// components
import { FormBox } from './style';
import { useContext } from 'react';

// utils
import { removeMask } from 'utils/removeMask';
import { toast } from 'react-toastify';

const CadastroUnidade = ({ getAllIUnit, ...others }) => {
    const theme = useTheme();
    const api = useApi();
    const scriptedRef = useScriptRef();
    const [submitError, setSubmitError] = useState(null);

    const handleRegister = async (values) => {
        // monta um objeto apenas com valores !== de ""
        const filteredValues = Object.entries(values).reduce((acc, [key, value]) => {
            if (value !== '') {
                acc[key] = value;
            }
            return acc;
        }, {});

        // monta o payload final
        const unidade = filteredValues;
        console.log(unidade);
        try {
            const response = await api.createUnit(unidade);
            toast.success('Cadastrado com sucesso!');
            clearValues(values);
            getAllIUnit();
        } catch (error) {
            toast.error(error.response.data.erro);
            setSubmitError(error.response.message);
        }
    };

    const maxLimit = (e) => {
        const regex = /^.{0,10}$/;
        const newValue = e.target.value;
        if (regex.test(newValue)) {
            setInputValue(newValue);
        } else {
            setInputValue(newValue.slice(0, 10));
        }
    };

    function isAnyFieldEmpty(values) {
        const fieldsToCheck = ['descricao', 'unidade'];

        for (const field of fieldsToCheck) {
            if (values[field].trim() === '') {
                return true;
            }
        }

        return false;
    }

    const clearValues = (values) => {
        values.descricao = '';
        values.unidade = '';
    };

    return (
        <Formik
            initialValues={{
                descricao: '',
                unidade: '',
                submit: null
            }}
            validationSchema={Yup.object().shape({
                descricao: Yup.string().max(10, 'Limite de 10 caracteres').required('Descrição é obrigatório'),
                unidade: Yup.string().max(10, 'Limite de 10 caracteres').required('Unidade é obrigatório')
            })}
            onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
                try {
                    if (scriptedRef.current) {
                        setStatus({ success: true });
                        setSubmitting(false);
                    }
                    handleRegister(values);
                } catch (err) {
                    if (scriptedRef.current) {
                        setStatus({ success: false });
                        setErrors({ submit: err.msg });
                        setSubmitting(false);
                    }
                }
            }}
        >
            {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
                <form noValidate onSubmit={handleSubmit} {...others} style={{ display: 'flex', flexDirection: 'column' }}>
                    <FormBox>
                        <FormControl
                            fullWidth
                            error={Boolean(touched.descricao && errors.descricao)}
                            sx={{ ...theme.typography.customInput }}
                        >
                            <InputLabel htmlFor="outlined-adornment-descricao-register">Descrição</InputLabel>
                            <OutlinedInput
                                id="outlined-adornment-descricao-register"
                                type="text"
                                value={values.descricao}
                                name="descricao"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                inputProps={{}}
                            />
                            {touched.descricao && errors.descricao && (
                                <FormHelperText error id="standard-weight-helper-text--register">
                                    {errors.descricao}
                                </FormHelperText>
                            )}
                        </FormControl>

                        <FormControl fullWidth error={Boolean(touched.unidade && errors.unidade)} sx={{ ...theme.typography.customInput }}>
                            <InputLabel htmlFor="outlined-adornment-unidade-register">unidade</InputLabel>
                            <OutlinedInput
                                id="outlined-adornment-unidade-register"
                                type="text"
                                value={values.unidade}
                                name="unidade"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                inputProps={{}}
                            />
                            {touched.unidade && errors.unidade && (
                                <FormHelperText error id="standard-weight-helper-text--register">
                                    {errors.unidade}
                                </FormHelperText>
                            )}
                        </FormControl>
                    </FormBox>

                    {errors.submit && (
                        <Box sx={{ mt: 3 }}>
                            <FormHelperText error>{errors.submit}</FormHelperText>
                        </Box>
                    )}

                    {/* BOTÕES */}
                    <Box sx={{ mt: 2 }}>
                        <AnimateButton>
                            <Button
                                sx={{ marginBottom: '3em' }}
                                disableElevation
                                disabled={isSubmitting || isAnyFieldEmpty(values)}
                                fullWidth
                                size="large"
                                type="submit"
                                variant="contained"
                                color="primary"
                            >
                                {isSubmitting || isAnyFieldEmpty(values) ? 'Descrição da unidade está faltando' : 'Cadastrar Unidade'}
                            </Button>
                        </AnimateButton>
                    </Box>
                </form>
            )}
        </Formik>
    );
};

export default CadastroUnidade;
